import Marionette from 'lib/marionette'
import template from 'templates/admin/codeBundle'
import itemTemplate from 'templates/admin/codeBundleItem'

import Toastr from 'toastr'

import Socket from 'lib/socket'
import FileUtils, {isZipType} from 'lib/file'

import Debug from 'debug'
const debug = Debug('pandore:views:admin:codeBundleList')

const GENERIC_UPLOAD_ERROR = 'UPLOAD_ERROR'

const EmptyView = Marionette.View.extend({
	className: 'emptyview',
	template: ()=> 'No bundle found.',
})

const CodeBundleItem = Marionette.View.extend({
	template: itemTemplate,
	tagName: 'tr',
	className: 'bundleItem vcenter',

	ui: {
		selectButton: 'button.select',
		deleteButton: 'button.delete',
	},

	events: {
		'longpress @ui.selectButton': 'handleSelect',
		'longpress @ui.deleteButton': 'handleDelete',
	},

	initialize() {
		debug('Initializing CodeBundleItem:',this.options)
	},

	onRender() {
		this.ui.selectButton.enableLongpress()
		this.ui.deleteButton.enableLongpress()
	},

	handleSelect() {
		this.trigger('select', this.model.get('name'), this.model.get('version'))
	},

	handleDelete() {
		this.trigger('delete', this.model.get('name'), this.model.get('version'))
	},
})

const CodeBundleListView = Marionette.CollectionView.extend({
	template,
	className: 'gamecode container',

	emptyView: EmptyView,
	childView: CodeBundleItem,
	childViewContainer: 'tbody',
	childViewEventPrefix: 'childview',

	events: {
		'click #uploadButton': 'handleUpload',
	},

	initialize() {
		debug('Initializing CodeBundleListView:',this.options)
		this.collection = new Marionette.Collection()
		this.refreshList()
	},

	serializeData() {
		return {
			version: this.version,
		}
	},

	async refreshList() {
		try {
			const result = await Socket.emit('codebundle:list')
			debug('Received list:',result)
			this.collection.set(result)
		} catch(err) {
			console.error('Error fetching list:',err)
			Toastr.error(`Error fetching list: ${err}`)
		}
	},

	async handleUpload() {
		try {
			const file = await FileUtils.selectFile('.zip')
			this.uploadFile(file)
		} catch(err) {
			console.error(err)
			Toastr.error(err)
		}
	},

	async uploadFile(file) {
		debug('Uploading file:', file)
		if (!isZipType(file.type)) {
			console.error('File to upload isn\'t supported:', file.type)
			Toastr.error('File to upload isn\'t supported')
			return
		}

		try {
			await FileUtils.upload('services/codebundle/upload', {file})
			debug('File upload success')
			Toastr.success(`File uploaded successfully: ${file.name}`)

			this.refreshList()
		} catch(err) {
			Toastr.error(`Error while uploading ${file.name}: ${err?.message || err || GENERIC_UPLOAD_ERROR}`)
		}
	},

	async onChildviewDelete(name, version) {
		debug('Processing delete:', name, version)
		try {
			await Socket.emit('codebundle:delete', name, version)
			Toastr.success(`Code bundle deleted.`)
			this.refreshList()
		} catch(err) {
			console.error('Error deleting bundle:',err)
			Toastr.error(`Error deleting bundle: ${err}`)
		}
	},

	async onChildviewSelect(name, version) {
		debug('Processing select:', name, version)
		try {
			await Socket.emit('codebundle:select', name, version)
			Toastr.success(`Code bundle selected.`)
			this.refreshList()
		} catch(err) {
			console.error('Error selecting bundle:',err)
			Toastr.error(`Error selecting bundle: ${err}`)
		}
	},
})

export default CodeBundleListView
